import * as angular from 'angular';
import './styling.scss';
import * as template from './template.html';
import { HippoApiService } from 'services/hippoApi';
import { getFormattedPhoneNumber, getTruncatedEmail } from 'common/source/utilities/strings';
import { ModalService } from 'common/source/services/modal';

const module = angular.module('escrow-payment', []);

interface EscrowPaymentData {
    policyId: PolicyId;
    reason: string;
    email: string;
    phoneNumber: string;
}

interface EscrowPayment extends angular.IStrictController {
    data: EscrowPaymentData;
    onConfirm: () => void;
    close: () => void;
    formattedPhoneNumber: string;
    formattedEmail: string;
    preferredMethodOfCommunication: string;
}

module.component('escrowPayment', {
    template: template,
    bindings: {
        data: '<'
    },
    controller: function(
        this: EscrowPayment,
        hippoApiService: HippoApiService,
        modalService: ModalService,
        $scope: angular.IScope
    ) {
        this.$onInit = () => {
            $scope.$on('closePaymentEditSection', this.close);
        };

        this.onConfirm = () => {
            hippoApiService
                .contactRequest(this.data.policyId, this.data.reason, this.preferredMethodOfCommunication)
                .then(() => {
                    modalService.closeAllDialogs('confirmed');
                });
        };

        this.close = () => {
            modalService.closeAllDialogs();
        };
    }
});

export { module };
